export default "__VITE_ASSET__C43fe404__"